@let currentScore = store.currentScore();
@let maxScore = store.maxScore();
<div class="score-bar">
  <div class="score-bar-track" [attr.role]="standalone() ? 'status' : null"
       [attr.aria-label]="standalone() ? accessibleScoreStatus() : null"> <!-- //NOSONAR -->
    <div class="score-bar-fill" [style.width.%]="fillWidth()">
      <span class="score-bar-current" aria-hidden="true">{{ currentScore }}</span>
    </div>
    @if (showEarnedPoints()) {
      <span class="score-bar-earned" aria-hidden="true">{{ earnedPointsLabel() }}</span>
    }
    @if (currentScore !== maxScore) {
      <span class="score-bar-max" aria-hidden="true">{{ maxScore }}</span>
    }
  </div>
  @if (showIcon()) {
    <div class="score-bar-icon">
      <img src="assets/icons/award-trophy-star.svg" alt="">
    </div>
  }
</div>
